import { Route } from 'react-router-dom';
import ChannelProfile from './channelprofile/ChannelProfile';

const ChannelManagement: React.FC = () => {
	return <Route exact path="/channel-management/" component={ChannelProfile} />;
};

export default ChannelManagement;
